import { LABELS } from './labels.constants'

export const InspectionStatusLabel: Record<string, string> = {
  ['true']: LABELS.active,
  ['false']: LABELS.inactive
}
